/**
 * @copyright 2026 Cooltrax Pty Ltd. All rights reserved.
 */

import { FiCornerUpLeft, FiTrash2 } from 'react-icons/fi'

import { ShapeIcon } from '../components/ShapeIcon'
import { SHAPE_LABELS, type ShapeType } from '../types'

const SHAPES: ShapeType[] = ['polygon', 'rectangle', 'circle']

interface ShapeToolbarProps {
  tool: ShapeType
  onToolChange: (tool: ShapeType) => void
  canUndo: boolean
  onUndo: () => void
  canClear: boolean
  onClear: () => void
}

/** Above the editor's map: the three shapes, then Undo and Clear. */
export const ShapeToolbar = ({ tool, onToolChange, canUndo, onUndo, canClear, onClear }: ShapeToolbarProps) => (
  <div className="flex flex-wrap items-center gap-2">
    <div className="join" role="radiogroup" aria-label="Shape">
      {SHAPES.map((shape) => (
        <button
          key={shape}
          type="button"
          role="radio"
          aria-checked={tool === shape}
          onClick={() => onToolChange(shape)}
          className={`join-item btn btn-sm ${tool === shape ? 'btn-primary' : 'btn-ghost border border-base-300'}`}
        >
          <ShapeIcon type={shape} />
          {SHAPE_LABELS[shape]}
        </button>
      ))}
    </div>
    <div className="w-px h-6 bg-base-300" />
    <button
      type="button"
      className="btn btn-sm btn-ghost"
      onClick={onUndo}
      disabled={!canUndo}
      title="Undo the last change"
    >
      <FiCornerUpLeft /> Undo
    </button>
    <button
      type="button"
      className="btn btn-sm btn-ghost"
      onClick={onClear}
      disabled={!canClear}
      title="Remove the shape and draw again"
    >
      <FiTrash2 /> Clear
    </button>
  </div>
)
